import React from "react"

function Dashboard() {
  return <div></div>
}

export default Dashboard
